import { useEffect, useState } from 'react';
import {
    Checkbox,
    FormControl,
    InputLabel,
    Select,
    OutlinedInput,
    ListItemText,
    MenuItem,
    Divider,
    ListSubheader,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setMatrixCampaigns } from '../../../../stores/redux/actions';
import { useTranslation } from 'react-i18next';
import { CampaignStatus, CampaignStatuses } from '../../../../types/enums/campaign-enums';

type CampaignListItem = {
    id: number;
    name: string;
    status: number;
    selected: boolean;
};

type setCampaignOptionProps = {
    allSelection: 'selectAll' | 'deselectAll' | 'none';
};

export const SCUISelectCampaigns = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const matrixStore = useSelector((state: any) => state.campaignMatrixList);
    const campaignsStore = useSelector((state: any) => state.campaignMatrixCampaigns);
    const liveCampaignStore = useSelector((state: any) => state.campaignLiveCampaign);

    const [selectedList, setSelectedList] = useState<CampaignListItem[]>(
        matrixStore.data?.campaignRules.map((x: any) => {
            return {
                id: x.id,
                name: x.title,
                status: x.status,
                selected: true,
            };
        }) as CampaignListItem[]
    );

    const handleChange = (event: any) => {
        const {
            target: { value },
        } = event;

        let _selectedList = [...selectedList];

        const currentValue = value as CampaignListItem[];

        campaignsStore.data.map((x: any) => {
            const _currentIndex = campaignsStore.data.findIndex((y: any) => y.id == x.id);

            const _selectedIndex = _selectedList.findIndex((y: any) => y.id == x.id);
            const _selected = _selectedList[_selectedIndex].selected;

            const _item = currentValue.find((s: any) => s.id == x.id);

            //option'ın değişmişse aktifken pasife, pasifken aktife alınmasını veya mevcut hali neyse onu sağlar.
            const selectedValue: boolean =
                _item == undefined
                    ? _selected
                        ? false
                        : _selected // _selected == true ise kullanıcı aktifken pasife almıştır. _selected == false ise mevcut değerini yansıtır.
                    : _item.selected == false
                      ? true
                      : _selected; // _item.selected == false ise kullanıcı pasifken akitfe almıştır. _item.selected == true ise mevcut değerini yansıtır

            if (_selectedIndex == -1) {
                _selectedList.push({ ...x, selected: false });
            } else {
                _selectedList[_currentIndex].selected = selectedValue;
            }
        });

        setSelectedList(_selectedList as CampaignListItem[]);
    };

    const handleAllSelection = ({ selected }: { selected: boolean }) => {
        if (matrixStore.data?.campaignRules.length == 0) return;

        setCampaignOptions({
            allSelection: selected ? 'selectAll' : 'deselectAll',
        });
    };

    const handleClose = (event: any) => {
        event.preventDefault();
        setCampaignOptions({
            allSelection: 'none',
        });
    };

    const setCampaignOptions = ({ ...props }: setCampaignOptionProps) => {
        const { allSelection } = props;

        const liveCampaignStatus = liveCampaignStore.data;
        const conditionStatuses: number[] =
            liveCampaignStatus === -1 ? CampaignStatuses.map((x: any) => x.id) : [CampaignStatus.Active];

        const _campaigns = matrixStore.data?.campaignRules
            .filter((x: any) => conditionStatuses.includes(x.status))
            .map((rule: any) => {
                const selected =
                    allSelection == 'none'
                        ? (selectedList.find((s) => s.id == rule.id)?.selected ?? false)
                        : allSelection == 'selectAll';
                return {
                    id: rule.id,
                    name: rule.title,
                    status: rule.status,
                    selected: selected,
                };
            }) as CampaignListItem[];

        setSelectedList(_campaigns);
        dispatch(setMatrixCampaigns(_campaigns));

        return _campaigns;
    };

    useEffect(() => {
        setCampaignOptions({
            allSelection: 'none',
        });
    }, [matrixStore, liveCampaignStore]);

    return (
        <div>
            <FormControl sx={{ m: 1, width: 300 }}>
                <InputLabel id="campaign-name-label">{t('campaignManagement.matrix.selectCampaigns')}</InputLabel>
                <Select
                    labelId="campaign-name-label"
                    id="campaignName"
                    name="campaignName"
                    multiple
                    value={selectedList.filter((x: any) => x.selected)}
                    onChange={handleChange}
                    input={<OutlinedInput label={t('campaignManagement.matrix.selectCampaigns')} />}
                    renderValue={() =>
                        selectedList
                            .filter((x: any) => x.selected)
                            .map((s: any) => s.name)
                            .join(', ')
                    }
                    onClose={handleClose}
                >
                    <ListSubheader
                        style={{
                            display: 'flex',
                            justifyContent: 'space-evenly',
                            fontSize: '16px',
                            borderBottom: '1px solid #e0e0e0',
                        }}
                    >
                        <span
                            style={{ margin: '4px', cursor: 'pointer' }}
                            onClick={() => handleAllSelection({ selected: true })}
                        >
                            <a style={{ textDecorationLine: 'underline' }}>
                                {t('campaignManagement.matrix.selectAll')}
                            </a>
                        </span>
                        <Divider orientation="vertical" flexItem />
                        <span
                            style={{ margin: '4px', cursor: 'pointer' }}
                            onClick={() => handleAllSelection({ selected: false })}
                        >
                            <a style={{ textDecorationLine: 'underline' }}>
                                {t('campaignManagement.matrix.deselectAll')}
                            </a>
                        </span>
                    </ListSubheader>
                    {campaignsStore.data.map((c: any) => {
                        return (
                            <MenuItem key={c.id} value={c}>
                                <Checkbox checked={c.selected} />
                                <ListItemText primary={`${c.id} - ${c.name}`} />
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </div>
    );
};
